/**
 * Lumis Experience (lum_track) for Allos mall top bar strips (header + secondary banner).
 * Depends on `analytics/lum-experience-utils.js` (window.AllosLumExperience), loaded first.
 *
 * Impression: once per anchor when the strip becomes visible (IntersectionObserver, or visibility poll).
 * Click: capture phase on links with data-allos-top-bar-* attributes.
 */
(function (window, document) {
  'use strict';

  var IMPRESSION = 'allos_top_bar_impression';
  var CLICK = 'allos_top_bar_click';
  var VISIBILITY_POLL_MS = 200;
  var VISIBILITY_WAIT_MS = 15000;

  var api = window.AllosLumExperience;
  if (!api || !api.emitWhenReady || !api.decodeURIComponentAttr || !api.pollUntil) {
    return;
  }

  function payloadFromAnchor(anchor) {
    if (!anchor || !anchor.getAttribute) {
      return null;
    }
    var rawTitle = anchor.getAttribute('data-allos-top-bar-title');
    var placement = anchor.getAttribute('data-allos-top-bar-placement');
    if (!rawTitle || !placement) {
      return null;
    }
    var title = api.decodeURIComponentAttr(rawTitle);
    if (!title || title === '') {
      return null;
    }
    if (placement !== 'header' && placement !== 'banner') {
      return null;
    }
    return {
      // eslint-disable-next-line camelcase -- monitor field ids
      top_bar_title: title,
      // eslint-disable-next-line camelcase -- monitor field ids
      top_bar_placement: placement,
    };
  }

  function emitImpressionOnce(anchor) {
    var data = payloadFromAnchor(anchor);
    if (!data) {
      return;
    }

    function fire() {
      var p = payloadFromAnchor(anchor);
      if (p) {
        api.emitWhenReady(IMPRESSION, p);
      }
    }

    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(
        function (entries, observer) {
          for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            if (!entry.isIntersecting) {
              continue;
            }
            fire();
            observer.unobserve(entry.target);
          }
        },
        { threshold: 0.01, rootMargin: '0px' }
      );
      io.observe(anchor);
      return;
    }

    api.pollUntil(
      function () {
        var r = anchor.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var visible = r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < vh && r.top + r.height > 0;
        return visible ? true : null;
      },
      function () {
        fire();
      },
      VISIBILITY_POLL_MS,
      VISIBILITY_WAIT_MS
    );
  }

  function init() {
    var anchors = document.querySelectorAll('a[data-allos-top-bar-title][data-allos-top-bar-placement]');
    for (var i = 0; i < anchors.length; i++) {
      if (payloadFromAnchor(anchors[i])) {
        emitImpressionOnce(anchors[i]);
      }
    }

    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) {
          return;
        }
        var anchor = t.closest('a[data-allos-top-bar-title][data-allos-top-bar-placement]');
        if (!anchor) {
          return;
        }
        var p = payloadFromAnchor(anchor);
        if (p) {
          api.emitWhenReady(CLICK, p);
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
